<template>
  <div class="main_container">
    <div class="draw-part">
        <div class="left-draw">
            <div class="turntable_box">
                <ul class="rotate">
                    <li
                    v-for="(item, index) in awardsList"
                    :key="item.itemId"
                    :class="['award' + index, { active: index == current }]"
                    class="award">
                        <el-tooltip placement="bottom" :enterable="false">
                            <div slot="content"><img :src="item.descriptImgUrl" alt=""></div>
                            <div class="one-prize" :class="index == current? 'mask':''">
                                <img :src="item.imgUrl" alt />
                                <p>{{item.itemName}}X{{item.amount}}</p>
                            </div>
                        </el-tooltip>
                    </li>
                    <div class="start-btn animate-pictrue" @click="start"></div>
                </ul>
            </div>
            <div class="number">
                <p>当日剩余抽奖次数: {{this.awardsCount == 0? 1:0}}</p>
                <p>已抽奖次数: {{this.awardsCount}}</p>
            </div>
        </div>
        <div class="right-prize">
            <img src="@/assets/images/draw/scale.png" alt="">
            <!-- {{pharseDays*20}} -->
            <div class="light_box" :style="'top:'+lightHeight+'px'">
                <!-- <img src="@/assets/images/draw/light_icon.png" alt=""> -->
             
                <div class="light" style="">

                </div>
            </div>
            <div class="nav">
                <ul>
                        <!-- <li :class="pharseDays >= 2? 'active':''">成圣<p></p></li>
                    <li :class="pharseDays == 3? 'active':''"><p>大成</p></li>
                    <li ><p>初窥</p></li> -->
                    <li ><p></p></li>
                    <li ><p></p></li>
                
                    <li :class="pharseDays >= 10? 'active':''"><p>成圣</p></li>
                    <li ><p></p></li>
                    <li ><p></p></li>
                    <li ><p></p></li>
                    <li :class="pharseDays >= 6? 'active':''"><p>大乘</p></li>
                    <li ><p></p></li>
                    <li ><p></p></li>
                    <li :class="pharseDays >= 3? 'active':''"><p>初窥</p></li>
                    <li ><p></p></li>
                    <li ><p></p></li>
                </ul>
            </div>
            <div class="list">
                <ul>
                    <li>
                        <p>{{phaseListOne.itemName}}</p>
                        <div class="p-list">
                            <el-tooltip placement="bottom" :enterable="false">
                                <div class="pop-img" slot="content"><img :src="phaseListOne.descriptImgUrl" alt=""></div>
                                <a href="#"><img :src="phaseListOne.imgUrl" alt=""></a>
                            </el-tooltip>
                        </div>
                    </li>
                    <li>
                        <p>{{phaseListTwo.itemName}}</p>
                        <div class="p-list">
                            <el-tooltip placement="bottom" :enterable="false">
                                <div class="pop-img" slot="content"><img :src="phaseListTwo.descriptImgUrl" alt=""></div>
                                <a href="#"><img :src="phaseListTwo.imgUrl" alt=""></a>
                            </el-tooltip>
                        </div>
                    </li>
                    <li>
                        <p>{{phaseListThree.itemName}}</p>
                        <div class="p-list">
                            <el-tooltip placement="bottom" :enterable="false">
                                <div class="pop-img" slot="content"><img :src="phaseListThree.descriptImgUrl" alt=""></div>
                                <a href="#"><img :src="phaseListThree.imgUrl" alt=""></a>
                            </el-tooltip>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!--我获得的奖励-->
    <div class="my-award">
        <ul>
            <li v-for="(item, index) in myAwardsList" :key="index">
                <el-tooltip placement="bottom">
                    <div slot="content"><img :src="item.descriptImgUrl" alt=""></div>
                    <a href="#">
                        <img :src="item.imgUrl" alt="">
                        <p>{{item.itemName}}X{{item.amount}}</p>
                    </a>
                </el-tooltip>
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
import api from '../api/api'
export default {
    name: "luckSpin",
    props: ['loginStatus'],
    watch: {
        /**
         * 监听props中tab选项卡所选项
         */
        loginStatus (val, oldVal) {
            this.isLogin = val;
            if(val == "login") {
                // 获取抽奖次数
                this.getAwardCount();
                this.getWinAwardData();
            }
        }
    },
    data() {
        return {
            // {boolean} 登录状态
            isLogin: '',
            // {boolean} 转动状态
            isRuningLucky: false,
            // {array} 奖品列表
            awardsList: [],
            // {array} 阶段奖品列表
            phaseList: [],
            phaseListOne: {},
            phaseListTwo: {},
            phaseListThree: {},
            // {number} 当前索引值
            current: 0,
            // {number} 时间->速度
            speed: 200,
            // {number} 基数
            diff: 15,
            lightHeight:259,
            // {object} 抽中的奖品
            award: {
                itemId: '',
                itemName: '',
                amount: '',
            },
            // {number} 当前时间戳
            time: 0,
            // {number} 定时器
            timer: null,
            awardsCount: '',
            myAwardsList: [],
            pharseDays: 0,
        };
    },
    mounted() {
        // 获取奖品list
        this.getAwardData();
        // 获取阶段奖品信息
        this.getPharseAwardData();
            //  this.lightHeight = 259-(3)*20
                    // console.log(this.lightHeight)

    },
    methods: {
        /**
         * 获取今日抽奖次数
         */
        getAwardCount() {
            let data = {};
            api.getTodayDrawCount(data).then(res=>{
                if(res.data.result == 1) {
                    this.awardsCount = res.data.data;
                    // 更新抽奖次数
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        /**
         * 获取奖品list
         */
        getAwardData() {
            let data = {};
            api.getAwardList(data).then(res=>{
                if(res.data.result == 1) {
                    let getData = res.data.data;
                    this.awardsList = getData;
                    // console.log(getData, '奖品list');
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        /**
         * 获取阶段奖品信息
         */
        getPharseAwardData() {
            let data = {};
            api.getPharseAwardList(data).then(res=>{
                if(res.data.result == 1) {
                    let getData = res.data.data;
                    this.phaseList = getData;
                    this.phaseListOne = getData[0];
                    this.phaseListTwo = getData[1];
                    this.phaseListThree = getData[2];
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        // 开始抽奖
        start() {
            // 转动中，只执行一次
            if (this.isRuningLucky) {
                return;
            }
            // 开始抽奖
            this.getLottery();
            this.time = Date.now();
            this.speed = 200;
            this.diff = 12;
            // 开始抽奖
            this.isRuningLucky = true;
        },
        // 调接口获取奖品
        getLottery() {
            let data = {};
            
            api.getDrawResult(data).then(res=>{
                debugger
                if(res.data.result == 1) {
                    let getData = res.data.data;
                    // 所获得奖品赋值
                    this.award.itemId = getData.itemId;
                    this.award.itemName = getData.itemName;
                    this.award.amount = getData.amount;
                    // 阶段
                    this.pharseDays = getData.pharseDays;
                  
                    console.log(this.lightHeight)
                    debugger
                    this.awardsCount = 1;
                    this.move();
                     if(this.pharseDays > 13){
                       this.lightHeight = 2
                       return false
                    }else if(this.pharseDays != 0){
                        this.lightHeight = 259-(this.pharseDays)*20
                    }

               
                } else if(res.data.result == -4) {
                    this.isRuningLucky = false;
                    // 请绑定账号
                    this.$message.error(res.data.message);
                    setTimeout(() => {
                        // 向父组件传值
                        this.$emit('bindAccount', true);
                    }, 1000)
                } else {
                    this.isRuningLucky = false;
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
        // 开始转动
        move() {
            this.timer = setTimeout(() => {
                this.current++;
                if (this.current > 11) {
                    this.current = 0;
                }
                // 若抽中的奖品id存在，则开始减速转动
                if (this.award.itemId && (Date.now() - this.time) / 1000 > 4) {
                    this.speed += this.diff; // 转动减速
                    // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来
                    if ((Date.now() - this.time) / 1000 > 7 && this.award.itemId == this.awardsList[this.current].itemId) {
                        clearTimeout(this.timer);
                        setTimeout(() => {
                            // 开始抽奖
                            this.isRuningLucky = false;
                            this.$message({
                                message: `恭喜中奖${this.award.itemName}X${this.award.amount}`,
                                type: 'success'
                            });
                            // 更新我的获奖list
                            this.getWinAwardData();
                            setTimeout(() => {
                                // 默认选中第一个奖品
                                this.current = 0;
                            }, 3000)
                            // 向父组件传值
                            this.$emit('awardsResult', this.award);
                        }, 0);
                        return;
                    }
                } 
                else {
                    // 若抽中的奖品不存在，则加速转动
                    this.speed -= this.diff;
                }
                this.move();
            }, this.speed);
        },
        // 我的奖品list
        getWinAwardData() {
            let data = {};
            api.getWinAwardList(data).then(res=>{
                     debugger
                if(res.data.result == 1) {
                    let getData = res.data.data;
                    this.myAwardsList = getData.awardList;
                    // 阶段
                    this.pharseDays = getData.pharseDays;
                    //   this.pharseDays = 4
          

                    if(this.pharseDays > 13){
                       this.lightHeight = 2
                       return false
                    }else if(this.pharseDays != 0){
                        this.lightHeight = 259-(this.pharseDays)*20
                    }
                 
                     
                
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(res=>{})
        },
    }
};
</script>
<style lang="scss" scoped>
.light_box{
    position: absolute;
    top:259px;
    left:0px;
    width:52px;
    height:0px;
    left:2px;
    transition: all 1s;
    // z-index: -2;
    >div{
        width:52px;
        height:255px;
        background:url(../assets/images/draw/light_bg.png);
    }
}
.main_container {
    // 作用: 禁用弹窗里的滑动影响页面滑动
    &.prohibit {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    // 设置占位符字体颜色
    input::-webkit-input-placeholder {
        color: #a4a5a6;
        font-size: 26px;
    }
    .draw-part{
        @include flex-space-between();
        padding-top: 120px;
        height: 430px;
    }
    .left-draw{
        width: 520px;
        
        .turntable_box {
            margin: 0 auto;
            .rotate {
                position: relative;
                width: 455px;
                height: 275px;
                position: relative;
                // background-color: antiquewhite;
                li {
                    margin: 0 10px 10px 0;
                    float: left;
                    width: 80px;

                    .one-prize{
                        position: relative;
                        width: 80px;
                        height: 80px;
                        text-align: center;
                        background:url(../assets/images/draw/award-bg2.jpg) center top no-repeat;
                        img {
                            margin-top: 6px;
                            width: 46px;
                            height: 46px;
                        }
                        p{
                            @include text-ellipsis();
                            position: absolute;
                            z-index: 2;
                            bottom: 0;
                            width: 80px;
                            color: $color-blue;
                            text-align: center;
                            line-height: 24px;
                        }
                    }
                    &.active {
                        // color: rgba(8, 5, 6, 1)!important;
                        .mask {
                            background:url(../assets/images/draw/award-bg1.jpg) center top no-repeat;
                            width: 80px;
                            height: 80px;
                        }
                    }
                    &.award5 {
                        position: absolute;
                        top: 90px;
                        left: 360px;
                    }
                    &.award6 {
                        position: absolute;
                        top: 180px;
                        left: 360px;
                    }
                    &.award7 {
                        position: absolute;
                        top: 180px;
                        left: 270px;
                    }
                    &.award8 {
                        position: absolute;
                        top: 180px;
                        left: 180px;
                    }
                    &.award9 {
                        position: absolute;
                        top: 180px;
                        left: 90px;
                    }
                    &.award10 {
                        position: absolute;
                        top: 180px;
                        left: 0;
                    }
                    &.award11 {
                        position: absolute;
                        top: 90px;
                        left: 0;
                    }
                }
                .start-btn {
                    position: absolute;
                    width: 260px;
                    height: 80px;
                    top: 90px;
                    left: 90px;
                    background:url(../assets/images/draw/btn1.jpg) center top no-repeat;
                    text-align: center;
                }
            }
        }
        .number{
            padding: 20px 0;
            p{
                font-size: 16px;
                color: $color-yellow1;
                line-height: 30px;
            }
        }
    }
    .right-prize{
        background:url(../assets/images/draw/level.png) center top no-repeat;
        width: 291px;
        height: 259px;
        overflow: hidden;
        position: relative;
        @include flex-space-between();
        >img{
            position: absolute;
            /* width: 56px; */
            z-index: 9;
            left: 2px;
            top: 18px;
        }
        
        .nav{
            margin: 2px 0 0 0;
            width: 57px;
            ul{
                padding-top:15px;
                li{
                    width: 57px;
                    height: 20px;
                    position: relative;
                    z-index: 9;
                    // background:red;
                    @include flex-center();
                    p{
                        font-size: 14px;
                        color: $color-blue;
                    }
                }
                .active{
                    // margin-bottom: 1px;
                    p{
                          color: rgba(8, 5, 6, 1)!important;
                    }
                  
                    // background:url(../assets/images/draw/hover1.jpg) center top repeat-y;
                    // p{
                    //     font-size: 14px;
                    //     color: $color-blue1;
                    // }
                }
            }
        }
        .list{
            width: 195px;

            ul{
                padding: 10px 0 0 0;
                li{
                    margin-bottom: 30px;
                    padding-left: 80px;
                    @include flex-start();
                    height: 60px;
                    line-height: 60px;
                    p{
                        width: 66px;
                        font-size: 12px;
                        color: $color-white;
                    }
                    .p-list{
                        @include flex-start();
                        a{
                            margin:0 4px;
                            @include flex-align-center();
                        }
                        img{
                            width: 32px;
                            height: 32px;
                        }
                    }
                }
            }
        }
    }
    .my-award{
        padding: 10px 50px;
        ul{
            @include flex-start();
            li{
                padding: 0 10px;
                text-align: center;
                a{
                    img{
                        width: 46px;
                        height: 46px;
                    }
                    p{
                        line-height: 26px;
                        color: $color-blue;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LuckySpin.vue